/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type MeasurementUnit = "CM" | "IN" | "%future added value";
export type SbSharedRefineMenuDimensionUnitRadioSelect_user$ref = any;
export type SbSharedRefineMenuDimensionUnitRadioSelect_user = {
    readonly serviceId: string | null;
    readonly profile: {
        readonly measurementUnit: MeasurementUnit | null;
    } | null;
    readonly " $refType": SbSharedRefineMenuDimensionUnitRadioSelect_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuDimensionUnitRadioSelect_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "profile",
            "storageKey": null,
            "args": null,
            "concreteType": "Profile",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "measurementUnit",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'fc2b7ccc2ef5138d191d7dc53da11515';
export default node;
